










import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import SignaturePad from 'signature_pad';
import {ResizeSensor} from 'css-element-queries';
import BindAttrs from '@/utils/binds-attrs';
import {SIGNOTEC_SERVICE_INSTANCE} from '@/services/signotec.service';

/**
 * General Component for Fields of type SIGNATURE
 */
@Component({
  mixins: [BindAttrs]
})
export default class AmetrasSignatureCaptureTemplate extends Vue {

  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() value!: string;
  @Prop() label!: string;
  signaturePad: SignaturePad | undefined;
  textValue: string = '';

  $refs!: {
    canvasEl: HTMLCanvasElement,
    canvasWrapperEl: HTMLDivElement
  };

  resizeSensor: ResizeSensor | null = null;
  height: number = 0;
  private ASPECT_RATIO = 1 / 3;

  redrawCanvas() {
    if (this.signaturePad) {
      const width = (this.$refs.canvasWrapperEl || {}).offsetWidth || 300;
      const oldHeight = this.height;
      this.height = width * this.ASPECT_RATIO;
      this.$refs.canvasEl.width = width;
      this.$refs.canvasEl.height = width * this.ASPECT_RATIO;
      const oldValue = this.signaturePad.toData();
      if (oldValue && oldValue.length > 0) {
        if (oldHeight > 0) {
          // migrate existing points to new aspect ratio
          const scale = this.height / oldHeight;
          for (const currentOldValue of oldValue) {
            for (const currentOldPoint of currentOldValue.points || []) {
              currentOldPoint.x = currentOldPoint.x * scale;
              currentOldPoint.y = currentOldPoint.y * scale;
            }
          }
        }
        this.signaturePad.fromData(oldValue, {
          clear: true
        });
      } else {
        this.signaturePad.clear();
      }
    } else {
      alert('Signature pad not initialized properly!');
    }
  }

  mounted() {
    if (this.value) {
      this.textValue = this.value.split('|')[1];
    }

    this.signaturePad = new SignaturePad(this.$refs.canvasEl, {});

    this.signaturePad.addEventListener('endStroke', () => {
      this.$emit('input', this.signaturePad?.toDataURL());
    });

    this.resizeSensor = new ResizeSensor(this.$refs.canvasWrapperEl, () => {
      this.redrawCanvas();
    });

    SIGNOTEC_SERVICE_INSTANCE.getNativeServiceSingleton().createConnectionAndOpenFirstPad(
        this.$refs.canvasWrapperEl,
        this.$refs.canvasEl,
        () => {
          setTimeout(() => {
            this.$emit('input', this.signaturePad?.toDataURL());
          });
        }
    ).then(() => {
      this.$store.commit('showSnack', {
        message: 'Signotec Pad ist einsatzbereit',
        color: 'success'
      });
    });
  }

  destroyed() {
    SIGNOTEC_SERVICE_INSTANCE.getNativeServiceSingleton().closeConnection();
    if (this.resizeSensor) {
      this.resizeSensor.detach();
    }
  }

}

